import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Page from 'Components/Page';
import * as actions from 'Store/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import { withStyles } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import queryString from 'query-string';
import Link from '@material-ui/core/Link';
import FormTextField from 'Components/FormTextField';
import Button from '@material-ui/core/Button';
import history from '../history';

const styles = theme => ({
  container: {
    marginTop: 30,
  },
  button: {
    color: '#fff',
    display: 'block',
    textAlign: 'center',
    width: 150,
  },
  link: {
    marginTop: 20,
  },
});

function FoundSomething({ setActiveModal, classes, submitLoginWithFireBase, registerWithFirebase }) {
  const { register, handleSubmit, errors } = useForm({
    defaultValues: {},
  });

  const onSubmit = async data => {
    const { tagCode } = data;
    setActiveModal('none');

    history.push(`/i/${tagCode}`);
  };

  const getHelperText = () => {
    if (errors.tagCode) {
      return errors.tagCode.message;
    }

    return "Please enter the 6 digit code. It's case sensitive.";
  };

  return (
    <Page hasNav={true}>
      <Container className={classes.container} component="main" maxWidth="sm">
        <Typography variant="h2" className={classes.login}>
          Found Something?
        </Typography>
        <FormTextField
          fullWidth
          label="Tag Code"
          name="tagCode"
          margin="normal"
          inputProps={{
            maxLength: 6,
          }}
          required
          error={!!errors.tagCode}
          helperText={getHelperText()}
          inputRef={register({
            required: 'Please enter 6 digit code',
            pattern: {
              value: /^[A-Z0-9]{6}$/i,
              message: 'Code must be 6 digits',
            },
          })}
          placeholder="Enter Tag Code"
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.button}
          component={Link}
          onClick={handleSubmit(onSubmit)}
          style={{ marginTop: 30, textDecoration: 'none' }}
        >
          Submit
        </Button>
      </Container>
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      submitLoginWithFireBase: actions.submitLoginWithFireBase,
      setActiveModal: actions.setActiveModal,
    },
    dispatch,
  );
}

export default withRouter(connect(null, mapDispatchToProps)(withStyles(styles)(FoundSomething)));
